export const app = {
  connectToYourWhatsappNumber: 'Anslut till ditt WhatsApp-nummer',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Anslut din WhatsApp-bot med ditt WhatsApp-nummer',
  connect: 'Anslut',
};
